// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__zLbJa","footer":"ModalError_footer__1mIFA"};